import React, { useCallback, useMemo } from 'react';
import { Button, T } from '@colonist/ui';
import { Table } from '@colonist/ui-platform';
import styles from '../FriendRequestTableShared/FriendRequestTableShared.module.scss';
const OutgoingFriendRequestActionsCell = ({ userId, onCancel })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.actionButtons,
        onClick: (event)=>event.stopPropagation()
    }, /*#__PURE__*/ React.createElement(Button, {
        "data-testid": "profile-sent-request-cancel-button",
        variant: "danger",
        size: "sm",
        onClick: ()=>onCancel(userId)
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:colonistCommon.buttons.cancel'
        }
    })));
export const OutgoingFriendRequestTable = ({ requests, onUserClick, onCancel })=>{
    const columns = useMemo(()=>[
            {
                id: 'username',
                overflow: 'truncate',
                header: ()=>/*#__PURE__*/ React.createElement(T, {
                        id: {
                            key: 'strings:profilePage.friends.tableHeaders.player'
                        }
                    }),
                cell: ({ value: username, row })=>/*#__PURE__*/ React.createElement("div", {
                        className: styles.row
                    }, /*#__PURE__*/ React.createElement("span", {
                        className: styles.username
                    }, username), /*#__PURE__*/ React.createElement(OutgoingFriendRequestActionsCell, {
                        userId: row.userId,
                        onCancel: onCancel
                    }))
            }
        ], [
        onCancel
    ]);
    const handleRowClick = useCallback((row)=>{
        onUserClick(row.userId, row.username);
    }, [
        onUserClick
    ]);
    return /*#__PURE__*/ React.createElement(Table, {
        testId: "profile-sent-requests-table",
        className: styles.container,
        data: requests,
        columns: columns,
        density: "comfortable",
        onRowClick: handleRowClick,
        emptyText: {
            key: 'strings:profilePage.friends.tabs.requestsSent.defaultBody'
        },
        showEmptyText: requests.length == 0
    });
};
